import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Layout, Select } from 'antd';
import isEmpty from 'lodash/isEmpty';
import ResultTable from './ResultTable';
import { PageContent, PageSpace } from '../styled';
import style from '../SummaryTab/index.scss';
import { returnFraudUserAccessByResource } from '../../../../util/TmFraudModuleFilter';
import {
  SCENARIO_RESULT_FAILED,
  DEFAULT_PAGINATION_PROPS,
  UNIFIED_ALERTS_SOURCE_IDS,
  ALERT__REQUEST_SOURCE_ID,
  REVIEW_REQUEST_STATUS,
  UNIFIED_ALERTS_SOURCE_IDS_FRAUD,
  UNIFIED_ALERTS_SOURCE_IDS_TM,
  UNIFIED_ALERTS_SOURCE_IDS_PREVENTION
} from './constants';
import FilterComponent, {
  handleFilterPopup,
  handleSortPopup
} from '../../../common/FilterComponent';
import { sortColumnProps, sortDataProps } from './sortProps';
import { convertDateInputToEpoch } from '../../../../util/timezone';
import { trmResources, ITEM_OPERATIONS } from '../../../../util/GlobalConstant';
import {
  hasAttributeValue,
  hasResourceOperation
} from '../../../../util/index';
import PreventionResultTable from './PreventionResultTable';
const { Content } = Layout;
const Result = ({
  scenarioResults,
  isLoading,
  error,
  resultAPIActions,
  authentication,
  trmActions
}) => {
  const {
    getAMLSCommonUnifiedAlerts,
    putAMLSCommonAlertPartyUpdate,
    fetchTypologiesActions
  } = resultAPIActions;
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_PROPS);
  const { current, pageSize } = pagination;
  const [sortFilterObj, setSortFilterObj] = useState({ filter: [] });
  const [isFraud, setIsFraud] = useState(false);
  const [isTMuser, setIsTMuser] = useState(false);
  const [isRTuser, setIsRTuser] = useState(false);
  const [isPrevention, setIsPrevention] = useState(false);
  const [currentSelectedFilter, setCurrentSelectedFilter] = useState();
  const fetchUnifiedAlerts = ({ page, pageSize, sourceId }) => {
    getAMLSCommonUnifiedAlerts({
      sourceIds: sourceId,
      offset: (page - 1) * pageSize,
      limit: pageSize,
      q: btoa(JSON.stringify(sortFilterObj))
    });
  };
  useEffect(() => {
    const userAccess = returnFraudUserAccessByResource(
      authentication.data,
      trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS
    );
    setIsFraud(userAccess.isFraud);
    setIsTMuser(userAccess.isTMuser);
    setIsRTuser(userAccess.isRTUser);
    const preventionResourceAccess = hasAttributeValue(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
      '24'
    );

    const detectionResourceAccess = hasAttributeValue(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
      '8'
    );

    const fraudResourceAccess = hasAttributeValue(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
      '20'
    );

    setIsFraud(fraudResourceAccess);
    setIsTMuser(detectionResourceAccess);
    setIsPrevention(preventionResourceAccess);
  }, [authentication]);

  useEffect(() => {
    if (isPrevention) {
      setCurrentSelectedFilter('PR');
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_PREVENTION;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (!isFraud && isTMuser) {
      setCurrentSelectedFilter('TM');
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_TM;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (isFraud && !isTMuser) {
      setCurrentSelectedFilter('Fraud');
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_FRAUD;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (isFraud && isTMuser) {
      setCurrentSelectedFilter('All');
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (!isFraud && !isTMuser && isRTuser) {
      setCurrentSelectedFilter('Fraud');
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_FRAUD_PREVENTION;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    }
  }, [isPrevention, isFraud, isTMuser]);

  useEffect(() => {
    if (isPrevention) {
      setCurrentSelectedFilter('PR');
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_PREVENTION;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (currentSelectedFilter === 'TM') {
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_TM;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (currentSelectedFilter === 'Fraud') {
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_FRAUD;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    } else if (currentSelectedFilter === 'All') {
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
    }
  }, [sortFilterObj, current, pageSize]);
  useEffect(() => {
    if (!isEmpty(error) && !isLoading) {
      message.error(SCENARIO_RESULT_FAILED, 1.5);
    }
  }, [error]);
  const onPaginationChange = useCallback((page, pageSize) => {
    setPagination({ current: page, pageSize });
  });
  const listenFilters = (data = []) => {
    setPagination(DEFAULT_PAGINATION_PROPS);
    const filter = data.map(({ filter, logic, item }) => {
      const strValues = [item?.val].flat().join();
      return { columnName: filter?.val, logic: logic?.val, value: strValues };
    });
    setSortFilterObj((pre) => ({ ...pre, filter }));
    handleFilterPopup(); // close Filter popup
  };
  const listenSort = (data = []) => {
    setPagination(DEFAULT_PAGINATION_PROPS);
    const sort = data.length
      ? { columnName: data[0].id, operator: data[0].defaultValue }
      : {};
    setSortFilterObj((pre) => ({ ...pre, sort }));
    handleSortPopup && handleSortPopup(); // close Sort popup
  };
  const triggerBulkStatusUpdate = (alertId) => {
    if (isEmpty(alertId)) {
      return;
    }
  };
  const onDropDownFilterChange = (selectedValue) => {
    setPagination(DEFAULT_PAGINATION_PROPS);
    if (selectedValue === 'TM') {
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_TM;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
      setCurrentSelectedFilter('TM');
    } else if (selectedValue === 'Fraud') {
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS_FRAUD;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
      setCurrentSelectedFilter('Fraud');
    } else if (selectedValue === 'All') {
      let sourceId = UNIFIED_ALERTS_SOURCE_IDS;
      fetchUnifiedAlerts({ page: current, pageSize, sourceId });
      setCurrentSelectedFilter('All');
    }
  };
  return (
    <Content>
      <PageSpace size={5} direction="vertical">
        <PageContent>
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '20px'
              }}>
              {isFraud && isTMuser && (
                <Select
                  options={[
                    { value: 'All', label: 'All' },
                    { value: 'TM', label: 'TM' },
                    { value: 'Fraud', label: 'Fraud' }
                  ]}
                  style={{ width: '150px' }}
                  defaultValue="All"
                  onChange={onDropDownFilterChange}
                  className={style.selectFilter}
                />
              )}
              <FilterComponent
                {...{ listenFilters, listenSort }}
                sortColumns={sortColumnProps}
                sortRows={sortDataProps}
                isLoading={isLoading}
                isResult={true}
              />
            </div>
          </div>
          {isPrevention ? (
            <PreventionResultTable
              isLoading={isLoading}
              results={scenarioResults?.payload}
              paginationProps={pagination}
              onPaginationChange={onPaginationChange}
              totalResults={scenarioResults?.total}
              onAlertIdClick={triggerBulkStatusUpdate}
              hasAccessToAlertDetails={hasResourceOperation(
                { data: authentication.data },
                trmResources.APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS,
                ITEM_OPERATIONS.READ
              )}
              typlogyActions={trmActions}
              fetchTypologiesActions={fetchTypologiesActions}
            />
          ) : (
            <ResultTable
              isLoading={isLoading}
              results={scenarioResults?.payload}
              paginationProps={pagination}
              onPaginationChange={onPaginationChange}
              totalResults={scenarioResults?.total}
              onAlertIdClick={triggerBulkStatusUpdate}
              hasAccessToAlertDetails={hasResourceOperation(
                { data: authentication.data },
                trmResources.APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS,
                ITEM_OPERATIONS.READ
              )}
            />
          )}
        </PageContent>
      </PageSpace>
    </Content>
  );
};
Result.propTypes = {
  scenarioResults: PropTypes.object,
  resultAPIActions: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.object
};
export default Result;
